<template>
  <v-page-content>
    <b-card class="subdivisions-card" responsive>
      <b-row class="mb-3">
        <b-col sm="12" md="7">
          <h4>
            <em class="fas fa-university"></em> <span class="ml-2"> Подразделения </span>
          </h4>
        </b-col>
      </b-row>
      <div class="ag-grid-vue-subdivisions-list mt-2" ref="gridDiv">
        <ag-grid-vue
          class="subdivisions ag-theme-material"
          :gridOptions="gridOptions"
          :columnDefs="columnDefs"
          @grid-ready="onGridReady"
          @gridSizeChanged="onGridSizeChanged"
          @rowSelected="onRowSelected"
          @filterChanged="onFilterChanged"
        >
        </ag-grid-vue>
      </div>
      <b-row class="sm pagination-row">
        <div class="ml-auto sm p-3 addButtons">
          <b-btn variant="primary"
                 class="addButton mr-1"
                 @click="onAddClicked"
          >
            <em class="fas fa-plus send-icon mr-1"></em> Добавить новое подразделение
          </b-btn>

          <b-btn variant="primary"
                 class="addButton mr-1"
                 @click="removeSubdivisionFromResource"
                 v-b-modal.subdivisionsRemoveModal
                 :disabled="storageLength < 1"
          >
            <span v-if="storageLength < 1"
                  v-b-tooltip.mouseover
                  title="Выберите одно или несколько подразделений"
            >
              <em class="fas fa-times-circle"></em> Удалить
            </span>
            <span v-else>
              <em class="fas fa-times-circle"></em> Удалить
            </span>
          </b-btn>
        </div>
      </b-row>
    </b-card>
    <subdivision-operations-modal
      :is-add-modal="isAddFunction"
      :chosen-subdivision="selectedSubdivision"
      @subdivisionOperationCompleted="forceFetch"
      />
    <subdivisions-remove-modal
      :chosen-subdivisions="removableSubdivisions"
      @subdivisionsRemoved="forceFetch"/>
  </v-page-content>
</template>

<script>
import { AgGridVue } from 'ag-grid-vue'

import _ from 'lodash'
import organizationApi from '@/api/organization'
import OrganizationActionsRenderer from '@/components/admin/actions/OrganizationActionsRenderer'
import AG_GRID_LOCALE_RU from '@/config/locale.ru'
import { clientWidthType } from '@/config/config'
import PartialMatchFilter from '@/components/helpers/filters/PartialMatchFilter'


const SubdivisionsRemoveModal = () => import('@/components/admin/modals/subdivisions/SubdivisionsRemoveModal.vue')
const SubdivisionOperationsModal = () => import('@/components/admin/modals/subdivisions/SubdivisionOperationsModal.vue')

export default {
  name: 'Subdivisions',
  components: {
    'ag-grid-vue': AgGridVue,
    SubdivisionOperationsModal,
    SubdivisionsRemoveModal
  },
  data() {
    return {
      /* Все, что касается таблицы */
      gridOptions: {
        defaultColDef: {
          headerName: '',
          autoHeight: false,
          sortable: true,
          headerClass: 'subdivisions-table-header',
          cellStyle: {
            'word-break': 'break-all'
          },
          filter: 'PartialMatchFilter'
        },
        suppressRowClickSelection: true,
        localeText: AG_GRID_LOCALE_RU,
        pagination: true,
        paginationPageSize: 20,
        rowHeight: 90,
        rowSelection: 'multiple',
        headerHeight: 40,
        enableCellTextSelection: true,
        suppressMenuHide: true,
        frameworkComponents: {
          OrganizationActionsRenderer,
          PartialMatchFilter
        },
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: 'Название',
          field: 'title',
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          checkboxSelection: true,
          cellStyle: null,
          width: 300
        },
        {
          headerName: 'Сайт',
          field: 'siteUrl'
        },
        {
          headerName: ' ',
          field: 'edit',
          width: 54,
          cellRenderer: 'OrganizationActionsRenderer',
          filter: null
        }
      ],
      context: {
        componentParent: this
      },
      rowData: null,
      /* Остальное */
      storageLength: 0,
      selectedSubdivisions: [],
      selectedSubdivision: null,
      removableSubdivisions: [],
      isAddFunction: true
    }
  },
  created() {
    sessionStorage.clear()
    this.storageLength = 0
    organizationApi.getSubdivisions().then(({ data }) => {
      this.rowData = data
      this.gridOptions.api.setRowData(this.rowData)
    })
    this.debouncedFetchFilteredData = _.debounce((filters, sorting) => {
      this.debouncedFetch(filters, sorting)
    }, 500)
  },
  beforeDestroy() {
    sessionStorage.clear()
  },
  methods: {
    onFilterChanged() {
      this.debouncedFetchFilteredData(this.gridOptions.api.getFilterModel())
    },
    onGridReady(params) {
      this.gridApi = params.api
      this.columnApi = params.columnApi
      if (this.$refs.gridDiv.clientWidth >= clientWidthType.COMMON) {
        this.gridApi.sizeColumnsToFit()
      }
      params.api.resetRowHeights()
    },
    onGridSizeChanged() {
      if (this.$refs.gridDiv.clientWidth >= clientWidthType.TIGHT) {
        this.gridApi.sizeColumnsToFit()
      }
    },
    onRowSelected(params) {
      sessionStorage.setItem(params.node.data.id, params.node.selected)
      const keys = Object.keys(sessionStorage)
      this.storageLength = keys.filter((el) => (sessionStorage.getItem(el) === 'true')).length
    },
    onParentEditClicked(data) {
      this.isAddFunction = false
      this.selectedSubdivision = data
      this.$bvModal.show('subdivisionOperationsModal')
    },
    onAddClicked() {
      this.gridOptions.api.deselectAll()
      this.isAddFunction = true
      this.selectedSubdivision = null
      this.$bvModal.show('subdivisionOperationsModal')
    },
    async forceFetch() {
      sessionStorage.clear()
      this.storageLength = 0
      organizationApi.getSubdivisions().then(({ data }) => {
        this.rowData = data
        this.gridOptions.api.setRowData(this.rowData)
      })
    },
    debouncedFetch(filters) {
      organizationApi.getFilteredOrganizations({
        filters: filters || ' ',
        type: 'subdivisions'
      })
        .then(({ data }) => {
          this.rowData = data
          this.gridOptions.api.setRowData(this.rowData)
        })
    },
    removeSubdivisionFromResource() {
      const keys = Object.keys(sessionStorage)
      this.selectedSubdivisions = keys.filter((el) => (sessionStorage.getItem(el) === 'true'))
      this.removableSubdivisions = this.rowData.filter(
        (subdivision) => this.selectedSubdivisions.includes(String(subdivision.id)),
      )
        .map((subdivisionForRemove) => ({
          id: subdivisionForRemove.id,
          title: subdivisionForRemove.title,
          siteUrl: subdivisionForRemove.siteUrl
        }))
      this.$bvModal.show('subdivisionsRemoveModal')
    }
  }
}
</script>

<style lang="scss">
  @import "../../sass/vendor/bootstrap/variables";

  .subdivisions {
    width: 100%;
    height: 100%;
  }

  .ag-grid-vue-subdivisions-list {
    height: calc(100vh - 280px);
    border-bottom: 1px solid lightgray;
  }

  .subdivisions-card .ag-grid-vue-subdivisions-list .ag-cell {
    display: flex;
    align-items: center;
    font-size: 15px;
    justify-content: left;
    text-align: left;
    white-space: normal;
    line-height: 1.4em;
  }

  .subdivisions-card .subdivisions-table-header {
    font-size: 15px;
    display: flex;
    align-items: center;
    justify-content: left;
    color: #000;
    font-weight: bold;
  }

  .subdivisions-card .ag-cell {
    padding-left: 24px !important;
  }

  .organizations-actions-renderer {
    cursor: pointer;
  }
</style>
